// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_order/get_purchase_order.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { PurchaseOrder } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetPurchaseOrderRequest
 */
export class GetPurchaseOrderRequest extends Message<GetPurchaseOrderRequest> {
  /**
   * Unique identifier for the purchase order
   *
   * @generated from field: string purchase_order_id = 1;
   */
  purchaseOrderId = "";

  /**
   * ID of the stock point to filter purchase orders by stock point
   *
   * @generated from field: string stock_point_id = 2;
   */
  stockPointId = "";

  /**
   * ID of the supplier to filter purchase orders by supplier
   *
   * @generated from field: string supplier_id = 3;
   */
  supplierId = "";

  constructor(data?: PartialMessage<GetPurchaseOrderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPurchaseOrderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPurchaseOrderRequest {
    return new GetPurchaseOrderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPurchaseOrderRequest {
    return new GetPurchaseOrderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPurchaseOrderRequest {
    return new GetPurchaseOrderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetPurchaseOrderRequest | PlainMessage<GetPurchaseOrderRequest> | undefined, b: GetPurchaseOrderRequest | PlainMessage<GetPurchaseOrderRequest> | undefined): boolean {
    return proto3.util.equals(GetPurchaseOrderRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetPurchaseOrderResponse
 */
export class GetPurchaseOrderResponse extends Message<GetPurchaseOrderResponse> {
  /**
   * List of purchase orders matching the criteria
   *
   * @generated from field: com.neulink.pharmacy.PurchaseOrder purchase_orders = 1;
   */
  purchaseOrders?: PurchaseOrder;

  /**
   * ID of the previous purchase order in the list, if available
   *
   * @generated from field: string previous_purchase_order_id = 2;
   */
  previousPurchaseOrderId = "";

  /**
   * ID of the next purchase order in the list, if available
   *
   * @generated from field: string next_purchase_order_id = 3;
   */
  nextPurchaseOrderId = "";

  /**
   * Total number of purchase orders matching the criteria
   *
   * @generated from field: int32 total_count = 4;
   */
  totalCount = 0;

  /**
   * Current index of the purchase order in the list
   *
   * @generated from field: int32 current_index = 5;
   */
  currentIndex = 0;

  constructor(data?: PartialMessage<GetPurchaseOrderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetPurchaseOrderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_orders", kind: "message", T: PurchaseOrder },
    { no: 2, name: "previous_purchase_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "next_purchase_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "current_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetPurchaseOrderResponse {
    return new GetPurchaseOrderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetPurchaseOrderResponse {
    return new GetPurchaseOrderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetPurchaseOrderResponse {
    return new GetPurchaseOrderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetPurchaseOrderResponse | PlainMessage<GetPurchaseOrderResponse> | undefined, b: GetPurchaseOrderResponse | PlainMessage<GetPurchaseOrderResponse> | undefined): boolean {
    return proto3.util.equals(GetPurchaseOrderResponse, a, b);
  }
}

